import { __experimentalUnitControl as UnitControl } from "@wordpress/components";

const BUnitControl = ({ px, p, em, ...props }) => {
  const units = [
    { value: "px", label: "px", default: px || 500 },
    { value: "%", label: "%", default: p || 100 },
    { value: "em", label: "em", default: em || 10 },
  ];
  return <UnitControl step={1} isResetValueOnUnitChange={true} units={units} {...props} />;
};

export default BUnitControl;
